import React, { useMemo } from 'react';
import { mergeClasses, Text } from '@fluentui/react-components';

import { useAggregatedData } from '../context';
import { AggregationMode, I18n } from '../types';

interface ResultsCountProps {
  i18n: I18n;
  className?: string;
  mode?: AggregationMode;
  label?: string;
}

export const ResultsCount: React.FC<ResultsCountProps> = ({
  i18n,
  className,
  mode = 'all',
  label: labelFromProps,
}) => {
  const { isLoading, getAggregatedData } = useAggregatedData();

  const label = useMemo(() => labelFromProps ?? i18n.getString(_TL_('Results')), [i18n, labelFromProps]);
  const count = useMemo(() => getAggregatedData(mode).length, [mode, getAggregatedData]);

  const textToDisplay = useMemo(() => {
    if (isLoading) {
      return label;
    }

    return `${label} (${count})`;
  }, [isLoading, label, count]);

  return (
    <Text className={mergeClasses('results-count', className)}>
      {textToDisplay}
    </Text>
  );
};
